import { Link } from 'react-router-dom';

export default function UnauthorizedPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center max-w-md px-6">
        <h1 className="text-3xl font-bold text-bark-900 dark:text-stone-100 mb-4">
          Insufficient Permissions
        </h1>
        <p className="text-stone-600 dark:text-stone-400 mb-6">
          You don&apos;t have permission to view this page. Please contact an administrator if
          you believe this is an error.
        </p>
        <Link to="/" className="text-moss-600 hover:text-moss-700 text-sm underline">
          Return to home
        </Link>
      </div>
    </div>
  );
}
